import { Inject, Injectable, Optional } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
const moment =  _moment;
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CustommatdateService  extends MomentDateAdapter{

  constructor( @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
    super(dateLocale);
  }
  override  parse(value:any, parseFormat:string): Moment | null {

    if (value && typeof value == 'string') {
      if(value.includes('/')){
        if(value.length > 9 && moment(value, 'MM/DD/YYYY').isValid()){
          return moment(value, 'MM/DD/YYYY');
        }
      }else if(value.length == 8 && moment(value, parseFormat).isValid()){
      return moment(value, parseFormat);
      }
    }
    return null;
  }

}
